<template>
  <el-card class="box-card form-screen mb-50 user-notice-form">
    <el-row>
      <el-col :span="24">
        <el-form :rules="rules" :model="form" ref="form" id="form" method="post" :action="urls.action">
          <el-form-item prop="title" :error="getErrorForField('title', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('notices.form.input_labels.title') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="title" v-model="form.title" :placeholder="$t('notices.form.input_placeholder.title')" class="title-notice"></el-input>
          </el-form-item>
          <el-form-item prop="notice_category_id" :error="getErrorForField('notices_category_id', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('notices.form.input_labels.category') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-select v-model="form.notice_category_id"
                      :placeholder="$t('notices.form.input_placeholder.category')">
              <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="content" :error="getErrorForField('content', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('notices.form.input_labels.content') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="content" v-model="form.content" :placeholder="$t('notices.form.input_placeholder.content')"
              type="textarea" class="textarea" :autosize="{ minRows: 29.5 }">
            </el-input>
          </el-form-item>
          <el-form-item prop="image_url" :error="getErrorForField('image_url', errors)" class="file-input">
            <label slot="label" class="el-form-item__label">{{ $t('notices.form.input_labels.image') }}</label>
            <label class="btn-upload">
              <input type="file" name="image" @change="onFileChange" id="image" accept="image/jpg, image/jpeg, image/png">ファイルを選択
            </label>
            <span class="file-name">{{ form.image_name }}</span>
            <div  class="full-width">
              <img class="image" :src="imageUrl" v-if="imageUrl">
            </div>
            <div class="el-form-item__error">{{ imageError }}</div>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="notice_category_id" :value="form.notice_category_id">
          <input type="hidden" name="image_url" :value="form.image_url">
          <input type="hidden" name="file_name" :value="form.image_name">
          <input type="hidden" name="id" :value="notice.id" v-if="notice && notice.id">
          <el-form-item class="btn-container">
            <el-button type="primary" @click="submit('form')" class="btn btn-submit btn-w135">{{ btn }}</el-button>
            <el-button @click="back" class="btn btn-back btn-w157">{{ $t('back') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  import { upload } from '../../../api/upload'
  import { IMAGE_EXTENSIONS } from '../../../constants'

  export default {
    props: {
      categories: { type: Array, required: true, default: [] },
      errors: { type: Object, required: false, default: {} },
      input: { type: Object, required: false },
      notice: { type: Object, default: {} },
      urls: { type: Object, required: true, default: {} },
      btn: { type: String, required: true, default: '' },
    },
    data() {
      return {
        form: {
          title: '',
          notice_category_id: '',
          content: '',
          image_url: '',
          image_name: this.$t('no_file_choose')
        },
        rules: {
          notice_category_id: [
            { required: true, message: this.$t('errors.required', [this.$t('notices.form.input_labels.category')]), trigger: 'blur' },
          ],
          title: [
            { required: true, message: this.$t('errors.required', [this.$t('notices.form.input_labels.title')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('notices.form.input_labels.title'), 255]), trigger: 'blur' },
          ],
          content: [
            { required: true, message: this.$t('errors.required', [this.$t('notices.form.input_labels.content')]), trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        imageError: '',
        imageUrl: '',
      }
    },

    methods: {
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid && !this.imageError) {
            document.querySelector(".el-container").classList.add("disabled");
            document.querySelector("#loader").style.display = "block";

            const form = document.getElementById("form");
            const file = document.getElementById('image').files[0];
            if (file) {
              this.uploadFileAndSubmit(file, form);
            } else {
              form.submit();
            }
          } else {
            return false;
          }
        });
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },

      back() {
        window.location.href = this.urls.back;
      },

      onFileChange(e) {
        const file = e.target.files[0];
        const extension = file.name.split('.').pop();

        this.form.image_name = file.name;

        if (!IMAGE_EXTENSIONS.includes(extension)) {
          this.imageError = this.$t('errors.image.type');
          this.imageUrl = '';
          return;
        }

        if (file.size > this.$maxSizeImage * 1000000) {
          this.imageError = this.$t('errors.image.max', [this.$t('staff.form.input_labels.avatar'), this.$maxSizeImage]);
          this.imageUrl = '';
          return;
        }

        this.imageError = '';
        this.imageUrl = URL.createObjectURL(file);
      },

      uploadFileAndSubmit(file, form) {
        upload(file)
        .then(response => response.json())
        .then(response => {
          this.form.image_url = response.data.url;
          this.form.image_name = response.data.file_name;
          this.imageUrl = response.data.url;
        })
        .then(() => {
          form.submit();
        });
      },

    },

    created() {
      const tempData = (Object.keys(this.input).length === 0) ? this.notice : this.input;
      this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));

      this.form.notice_category_id = (tempData.notice_category_id) ? parseInt(tempData.notice_category_id) : '';
      this.form.image_name = (tempData.file_name) ? tempData.file_name : this.$t('no_file_choose');
      this.imageUrl = (tempData.image_url) ? tempData.image_url : '';
   },
  }
</script>
<style lang="scss" scoped>
  .user-notice-form {
    .el-form {
      .el-input {
        width: 660px;
      }
      .el-select {
        width: 335px;
      }
      .el-textarea {
        width: 660px;
        .el-textarea__inner {
          height: 630px;
          padding: 20px 30px;
          letter-spacing: 1.3px;
          line-height: 29px;
        }
      }
      .image {
        width: 800px;
        height: 600px;
        margin-top: 20px;
      }
      .btn-upload {
        margin-left: 0px;
      }
      .el-form-item {
        .el-form-item-content {
          text-align: left;
        }
        &.btn-container .btn:first-child {
          margin-right: 0;
        }
      }
    }
  }
</style>
